import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-vh-country-stocks',
  templateUrl: './vh-country-stocks.component.html',
  styleUrls: ['./vh-country-stocks.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VhCountryStocksComponent {

}
